import Header from './Component/Header';
import LeftMenu from './Component/LeftMenu';
import Footer from './Component/Footer';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Login from './Master/Login';
import Timesheet from './Main/Timesheet';
import Mproject from './Master/M_project';
import Mprojectae from './Master/M_project_ae';
import Mconfiguration from './Master/M_configuration';
import Mcustomer from './Master/M_customer';
import Mcustomerview from './Master/M_customer_view';
import Mdepartment from './Master/M_department';
import Mholiday from './Master/M_holiday';
import Mpermission from './Master/M_permission';
import Mpermissionae from './Master/M_permission_ae';
import Mposition from './Master/M_position';
import Mpositionae from './Master/M_position_ae';
import Mstaff from './Master/M_staff';
import Mstaffae from './Master/M_staff_ae';
import Mtask from './Master/M_task';
import Mtimeoff from './Master/M_timeoff';
import Pathurl from './Class/Pathurl.json'
import ApproveTimesheet from './Main/ApproveTimesheet';
import ClearingTimesheet from './Main/ClearingTimesheet';
import Mholiday2 from './Master/M_holiday2';
import PosGraph from './Main/Pos_Graph';
import Mprojectview from './Master/M_project_view';
import ReportsumByProject from './PReport/Report_sumByProject';
import ReportsumByStaff from './PReport/Report_sumByStaff';
import ReportsumByTasks from './PReport/Report_sumByTasks';
import NoPermission from './Master/No_Permission.js';
import Welcome from './Master/Welcome.js';
import Mprojectsearch from './Master/M_project_search';
import ReportsumByPosition from './PReport/Report_sumByPosition';
import ReportsumByTransaction from './PReport/Report_sumByTransaction';
import ReportsumByTimeSheetByStaff from './PReport/Report_sumByTimeSheetByStaff';
import ReportTimesheetbyperiod from './PReport/Report_Timesheetbyperiod';
import MServiceinfo from './Master/M_service_info';

import Mcompany from './Master/M_company';
import Mcompanyae from './Master/M_company_ae';
import Mannouncement from './Master/M_announcement';
import Timeout from './Master/Timeout.js';




function App() {
  return (
    <>
      <Router>
        <Routes>

          <Route path={Pathurl.timesheet} element={<><Header/><LeftMenu/><Timesheet/><Footer/></>}></Route>
          <Route path={Pathurl.approveTimesheet} element={<><Header/><LeftMenu/><ApproveTimesheet/><Footer/></>}></Route>
          <Route path={Pathurl.clearingTimesheet} element={<><Header/><LeftMenu/><ClearingTimesheet/><Footer/></>}></Route>
         
          <Route path={Pathurl.m_Project} element={<><Header/><LeftMenu/><Mproject/><Footer/></>}></Route>
          <Route path={Pathurl.m_project_ae} element={<><Header/><LeftMenu/><Mprojectae/><Footer/></>}></Route>

          <Route path={Pathurl.report_sumByProject} element={<><Header/><LeftMenu/><ReportsumByProject/><Footer/></>}></Route>
          <Route path={Pathurl.report_sumByStaff} element={<><Header/><LeftMenu/><ReportsumByStaff/><Footer/></>}></Route>
          <Route path={Pathurl.report_sumByTasks} element={<><Header/><LeftMenu/><ReportsumByTasks/><Footer/></>}></Route>
          <Route path={Pathurl.report_sumByPosition} element={<><Header/><LeftMenu/><ReportsumByPosition/><Footer/></>}></Route>
          <Route path={Pathurl.report_sumByTransaction} element={<><Header/><LeftMenu/><ReportsumByTransaction/><Footer/></>}></Route>
          <Route path={Pathurl.report_sumByTimeSheetByStaff} element={<><Header/><LeftMenu/><ReportsumByTimeSheetByStaff/><Footer/></>}></Route>
          <Route path={Pathurl.report_Timesheetbyperiod} element={<><Header/><LeftMenu/><ReportTimesheetbyperiod/><Footer/></>}></Route>
          
          <Route path={Pathurl.m_configuration} element={<><Header/><LeftMenu/><Mconfiguration/><Footer/></>}></Route>

          <Route path={Pathurl.m_customer} element={<><Header/><LeftMenu/><Mcustomer/><Footer/></>}></Route>
          <Route path={Pathurl.m_customer_view} element={<><Header/><LeftMenu/><Mcustomerview/><Footer/></>}></Route>
          
          
          <Route path={Pathurl.m_department} element={<><Header/><LeftMenu/><Mdepartment/><Footer/></>}></Route>
          <Route path={Pathurl.m_holiday} element={<><Header/><LeftMenu/><Mholiday/><Footer/></>}></Route>
          <Route path={Pathurl.m_task} element={<><Header/><LeftMenu/><Mtask/><Footer/></>}></Route>
          <Route path={Pathurl.m_timeoff} element={<><Header/><LeftMenu/><Mtimeoff/><Footer/></>}></Route>

          <Route path={Pathurl.m_permission} element={<><Header/><LeftMenu/><Mpermission/><Footer/></>}></Route>
          <Route path={Pathurl.m_permission_ae} element={<><Header/><LeftMenu/><Mpermissionae/><Footer/></>}></Route>
         
          <Route path={Pathurl.m_position} element={<><Header/><LeftMenu/><Mposition/><Footer/></>}></Route>
          <Route path={Pathurl.m_position_ae} element={<><Header/><LeftMenu/><Mpositionae/><Footer/></>}></Route>
         
          <Route path={Pathurl.m_staff} element={<><Header/><LeftMenu/><Mstaff/><Footer/></>}></Route>
          <Route path={Pathurl.m_staff_ae} element={<><Header/><LeftMenu/><Mstaffae/><Footer/></>}></Route>
          <Route path={Pathurl.m_holiday2} element={<><Header/><LeftMenu/><Mholiday2/><Footer/></>}></Route>
          <Route path={Pathurl.pos_graph} element={<><Header/><LeftMenu/><PosGraph/><Footer/></>}></Route>
          <Route path={Pathurl.m_project_view} element={<><Header/><LeftMenu/><Mprojectview/><Footer/></>}></Route>
          <Route path={Pathurl.m_projectSearch} element={<><Header/><LeftMenu/><Mprojectsearch/><Footer/></>}></Route>
			    <Route path={Pathurl.no_permission} element={<><Header/><LeftMenu/><NoPermission/><Footer/></>}></Route>
          <Route path={Pathurl.welcome} element={<><Header/><LeftMenu/><Welcome/><Footer/></>}></Route>
          <Route path={Pathurl.m_serviceinfo} element={<><Header/><LeftMenu/><MServiceinfo/><Footer/></>}></Route>


          <Route path={Pathurl.m_company} element={<><Header/><LeftMenu/><Mcompany/><Footer/></>}></Route>
          <Route path={Pathurl.m_company_ae} element={<><Header/><LeftMenu/><Mcompanyae/><Footer/></>}></Route>
          <Route path={Pathurl.m_announcement} element={<><Header/><LeftMenu/><Mannouncement/><Footer/></>}></Route>

          <Route path={Pathurl.timeout} element={<><Timeout/></>}></Route>
          <Route end path="*" element={<><Login/></>}></Route> 
        </Routes>
      </Router> 
    </>
  );
}

export default App;
